// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type InfoCircle24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle24: FC<InfoCircle24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M12.9 16.5h-1.8v-5.4h1.8v5.4ZM12.641 9.041A.87.87 0 0 1 12 9.3a.87.87 0 0 1-.641-.259.87.87 0 0 1-.259-.641.87.87 0 0 1 .259-.641A.87.87 0 0 1 12 7.5a.87.87 0 0 1 .641.259.87.87 0 0 1 .259.641.87.87 0 0 1-.259.641Z" />
            <path
                d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-2 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default InfoCircle24;
